export enum FileMode {
    SeparateFiles = 'SeparateFiles',
    SingleFile = 'SingleFile'
}
